<template>
    <div>
        <page-title>编辑客服信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="昵称" prop="nickname">
                    <el-input v-model="form.nickname"/>
                </el-form-item>
                <el-form-item label="二维码" prop="pic_url">
                    <app-upload v-model="form.pic_url" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="form.sort"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加客服'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<style scoped>
    .host-ip-row {
        margin-top: 25px;
    }

    .host-ip-row:first-child {
        margin-top: 0;
    }
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            rules: {
                nickname: [
                    {required: true, message: '请填写客服昵称。'}
                ],
                pic_url: [
                    {required: true, message: '请填写客服图标。'}
                ]
            },
            form: {
                nickname: null,
                pic_url: '',
                sort: 1000
            }
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/customer/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form.nickname = e.data.data.nickname
                    this.form.pic_url = e.data.data.pic_url
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/customer/update',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/customer/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
